var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3753 14.2761C20.3887 14.374 20.4013 14.4663 20.408 14.5884L13.3459 21.6497H13.1826C12.1481 21.6497 11.3937 20.9187 11.2537 19.7832C11.0981 18.6478 11.1293 16.7036 11.2537 15.6693C11.4015 14.5961 12.1948 13.8574 13.1826 13.8574H14.5281L17.0947 11.7569C17.4058 11.4932 17.9581 11.2444 18.3858 11.2358C19.1636 11.2358 19.8791 11.781 20.1358 12.652C20.2369 13.0167 20.2758 13.383 20.3069 13.7321L20.3691 14.2306C20.3712 14.246 20.3733 14.2611 20.3753 14.2761ZM19.6574 18.8129C19.7632 18.7095 19.9973 18.6364 20.1031 18.6629C20.3893 18.736 20.4445 19.1458 20.4406 19.4677C20.4274 20.4025 20.3955 21.0526 20.3457 21.4547L20.3107 21.786L20.3101 21.7922C20.2769 22.1255 20.2425 22.4703 20.1443 22.8382C19.8845 23.7076 19.19 24.2722 18.4013 24.2722C18.3749 24.2722 18.3492 24.2722 18.3228 24.2714C17.8872 24.2714 17.4136 24.0102 17.1452 23.7823L16.1893 23.0427C15.8269 22.7729 15.9335 22.3413 16.1372 22.0916C16.2894 21.9059 18.1171 20.2284 19.078 19.3465C19.4043 19.0471 19.6306 18.8394 19.6574 18.8129Z",
    fill: "#2E2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6876 11.1268C24.413 10.8616 23.9915 10.8631 23.7271 11.1275L11.1272 23.7259C10.862 23.9911 10.862 24.4134 11.1295 24.691C11.2664 24.8178 11.436 24.8877 11.6079 24.8877C11.7836 24.8877 11.9641 24.8139 12.0893 24.6887L24.6884 12.0903C24.9544 11.8243 24.9544 11.3935 24.6876 11.1268Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/sound_off.f2df2082446e3c6f1a102e59c2169f15.svg";
export { ForwardRef as ReactComponent };